const headerData = [
    {
        prop: "id",
        label: "序号",
        columnwidth: 50
    },
    {
        prop: "PDCode",
        label: "编号",
        columnwidth: 100
    },
    {
        prop: "InvClassName",
        label: "产品线",
        columnwidth: 80
    },
    {
        prop: "MFName",
        label: "生产厂商",
        columnwidth: 220
    },
    {
        prop: "InvName",
        label: "产品名称",
        columnwidth: 180
    },
    {
        prop: "RegistrationNo",
        label: "注册证号",
        columnwidth: 210
    },
    {
        prop: "ShowName",
        label: "显示名称",
        columnwidth: 320
    },
    {
        prop: "InvTypeName",
        label: "产品类别",
        columnwidth: 80
    },
    {
        prop: "MarkupRate",
        label: "加价率",
        columnwidth: 80
    },
    {
        prop: "ShowNameForCombo",
        label: "授权申请名称",
        columnwidth: 200
    },
    // {
    //     prop: "MFName",
    //     label: "产品线名称",
    //     columnwidth: 210
    // },
    {
        prop: "CreatorName",
        label: "创建人",
        columnwidth: 130
    },
    {
        prop: "CreateTime",
        label: "创建时间",
        columnwidth: 120
    },
    {
        prop: "UpdaterName",
        label: "修改时间",
        columnwidth: 150,
    },
    {
        prop: "UpdateTime",
        label: "修改时间",
        columnwidth: 170
    },
    {
        prop: "RejectTime",
        label: "驳回时间",
        columnwidth: 120
    },
];
export default headerData;